import React from "react";
import Dialog from "@mui/material/Dialog";
import Slide from "@mui/material/Slide";
import styles from "./DialogPopup.module.css";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

function DialogPopup(props) {
  const { children, title, ...otherProps } = props;

  return (
    <Dialog
      TransitionComponent={Transition}
      className={styles.popup_root}
      classes={{
        paper:
          props.size && props.size === "large"
            ? styles.paper_big
            : styles.paper,
      }}
      keepMounted={false}
      disablePortal={false}
      disableScrollLock={true}
      container={() => document.body}
      {...otherProps}
    >
      <div className={styles.popup_header}>{title}</div>
      <div className={styles.popup_content}>{children}</div>
    </Dialog>
  );
}

export default DialogPopup;
